import { styled } from 'theme';

const Card = styled('div', {
  // Reset
  boxSizing: 'border-box',
  flexShrink: 0,

  // Custom
  backgroundColor: '$white',
  borderRadius: '$md',
  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12)',
});

export default Card;
